var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.device)?_c('color-indicator',{attrs:{"color":_vm.deviceStatusColors[_vm.device.status]}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }